<div kalDialogContent>

    <ng-container *ngIf="!!data.bodyTemplate; else textBodyTemplate">
        <ng-container *ngTemplateOutlet="data.bodyTemplate; context:data.bodyTemplateContext"></ng-container>
    </ng-container>

    <ng-template #textBodyTemplate>
        <ng-container *ngIf="data.body">
            <div [innerHTML]="data.body | sanitize: 'html'"></div>
        </ng-container>

        <ng-container *ngFor="let paragraph of data.paragraphs">
            <div [innerHTML]="paragraph | sanitize: 'html'"></div>
        </ng-container>
    </ng-template>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item" *ngIf="data.submitLabel">
            <kal-button kalTheme="primary"
                        (click)="submitDialog()">
                {{ data.submitLabel }}
            </kal-button>
        </div>

        <div class="gup-O-list__item" *ngIf="data.cancelLabel">
            <kal-button kalTheme="secondary"
                        (click)="cancelDialog()">
                {{ data.cancelLabel }}
            </kal-button>
        </div>

    </div>

</div>
